export enum QA_LINK {
  QUESTIONS = 'questions',
  ADMISSION = 'to-admission',
  ACCEPT = 'to-be-accepted',
  ANSWER = 'to-answer',
  CAT_APPROVE = 'to-approve-category',
  APPROVE_1 = 'to-approve-1',
  APPROVE_2 = 'to-approve-2',
  ALL_QUESTIONS = 'all-questions',
}